let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8xZDN")).then(() => parcelRequire('kRQuv'));